import { lazy } from "react";
const OtTradeBoardBase = lazy(() => import("app/pages/ot/tradeBoard/BoardBase"));
const MyDeals = lazy(() => import("app/pages/ot/myDeal/MyDeals"));
const TradePlans = lazy(() => import("app/pages/ot/tradePlan/TradePlans"));
const TradeInterests = lazy(() => import("app/pages/ot/tradeInterest/TradeInterests"));
const OtTradeConfirmBase = lazy(() => import("app/pages/ot/tradeConfirm/list/TradeConfirmBase"));
const OtTradeConfirmBoardDetail = lazy(() => import("app/pages/ot/tradeConfirm/detail/TradeConfirmBoardDetail"));
const OtTradeConfirmApplyDetail = lazy(() => import("app/pages/ot/tradeConfirm/detail/TradeConfirmApplyDetail"));
const ContractListBase = lazy(() => import("app/pages/cb/contractList/ContractListBase"));
const MoneyStatusBase = lazy(() => import("app/pages/ot/moneyStatus/MoneyStatusBase"));
const MoneyHistoryBase = lazy(() => import("app/pages/ot/moneyHistory/MoneyHistoryBase"));
const BillListBase = lazy(() => import("app/pages/cb/billList/BillListBase"));
const BillFormBase = lazy(() => import("app/pages/cb/billForm/BillFormBase"));
const BillDetailBase = lazy(() => import("app/pages/cb/billDetail/BillDetailBase"));
const BillFormModify = lazy(() => import("app/pages/cb/billForm/BillFormModify"));

const TradeContractForm = lazy(() => import("app/pages/cb/contractForm/ContractFormBase"));
const TradeContractDetail = lazy(() => import("app/pages/cb/contractDetail/ContractDetailBase"));
const TradeRpdc = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdc"));
const TradeRpdcForm = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdcForm"));
const TradeRpdcDetail = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdcDetail"))
const MoneyRpdc = lazy(() => import("app/pages/ot/moneyRpdc/MoneyRpdc"));
const MoneyRpdcForm = lazy(() => import("app/pages/ot/moneyRpdc/MoneyRpdcForm"));
const MoneyRpdcDetail = lazy(() => import("app/pages/ot/moneyRpdc/MoneyRpdcDetail"));
const VerifierList = lazy(() => import("app/pages/ot/verifier/VerifierList"));
const VerifierDetail = lazy(() => import("app/pages/ot/verifier/VerifierDetail"));
const VerifierForm = lazy(() => import("app/pages/ot/verifier/VerifierForm"));

export const otRouter: any = [
  // 에너지마켓 장외거래
  { path: '/ot/emission/trade', element: <OtTradeBoardBase />, },
  { path: '/ot/rec/trade', element: <OtTradeBoardBase />, },

  // 에너지마켓 장외거래 - confirm
  { path: '/ot/emission/contract', element: <OtTradeConfirmBase /> },
  { path: '/ot/emission/contract/board/detail', element: <OtTradeConfirmBoardDetail /> },
  { path: '/ot/emission/contract/apply/detail', element: <OtTradeConfirmApplyDetail /> },
  { path: '/ot/rec/contract', element: <OtTradeConfirmBase /> },
  { path: '/ot/rec/contract/board/detail', element: <OtTradeConfirmBoardDetail /> },
  { path: '/ot/rec/contract/apply/detail', element: <OtTradeConfirmApplyDetail /> },

  // 에너지마켓 내 거래
  //
  // 거래현황의 '내 거래글'·'내 거래요청'과 계약 진행을 한 화면에 모은다.
  // 백엔드는 대구와 공유하는 ot 서비스다(GET /confirm/my-deals · /trade/messages).
  { path: '/ot/emission/deals', element: <MyDeals /> },
  { path: '/ot/rec/deals', element: <MyDeals /> },

  // 배출권 매매 실적 및 계획(#24). 계획은 ot_trd_pln 에 저장하고 실적은
  // /report/oct/sb 가 준다 — 대비 계산은 tradePlanProgress.ts 에 있다.
  // REC 는 계획 대상이 아니다(배출권 거래제 의무가 아니다) — 경로가 하나뿐인 이유다.
  { path: '/ot/emission/plans', element: <TradePlans /> },

  // 매매 관심 조건(#17). 조건에 맞는 거래글이 등록되면 알림이 간다 —
  // 매칭은 서버가 거래글 등록 시점에 하고(TradeMatchNotifier) 화면은 조건만 관리한다.
  { path: '/ot/emission/interests', element: <TradeInterests /> },

  // 에너지마켓 계약관리
  { path: '/ot/contract', element: <ContractListBase /> },
  { path: '/ot/contract/form', element: <TradeContractForm /> },
  { path: '/ot/contract/detail', element: <TradeContractDetail /> },

  // 에너지마켓 유연자원시장 거래 현황
  { path: '/ot/money/hd/status', element: <MoneyStatusBase /> },

  // 에너지마켓 유연자원시장 이력관리
  { path: '/ot/money/hd/history', element: <MoneyHistoryBase /> },

  // 에너지마켓 부정거래 신고
  { path: '/ot/trade/rpdcs', element: <TradeRpdc /> },
  { path: '/ot/trade/rpdcs/form', element: <TradeRpdcForm /> },
  { path: '/ot/trade/rpdcs/detail', element: <TradeRpdcDetail /> },

  // 에너지마켓 정산조정 신청
  { path: '/ot/money/rpdcs', element: <MoneyRpdc /> },
  { path: '/ot/money/rpdcs/form', element: <MoneyRpdcForm /> },
  { path: '/ot/money/rpdcs/detail', element: <MoneyRpdcDetail /> },

  // 에너지마켓 공증기관 정보
  { path: '/ot/verifier', element: <VerifierList /> },
  { path: '/ot/verifier/detail', element: <VerifierDetail /> },
  { path: '/ot/verifier/form', element: <VerifierForm /> },

  // 에너지마켓 정산관리
  { path: '/ot/bill', element: <BillListBase /> },
  { path: '/ot/bill/form', element: <BillFormBase /> },
  { path: '/ot/bill/modify', element: <BillFormModify /> },
  { path: '/ot/bill/detail', element: <BillDetailBase /> },
];